/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Section_LocationInputs */

const cs_property_section_location = /** @type {(inputs: Property_Section_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalita`)
};

const en_property_section_location = /** @type {(inputs: Property_Section_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Property_Section_LocationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_section_location = /** @type {((inputs?: Property_Section_LocationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Section_LocationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_section_location(inputs)
	return cs_property_section_location(inputs)
});